import { ID_RE, SLUG_LEGACY_RE } from 'mk2/helpers/urls';

const ENTITY_ID = `:entityId(${ID_RE})`;
const GROUP_ID = `:groupId(${ID_RE})`;
const IMAGE_ID = `:imageId(${ID_RE})`;
const POST_ID = `:postId(${ID_RE})`;
const POST_SLUG = `:postSlug(${SLUG_LEGACY_RE})`;

export const groupPrefix = '/group';
export const listOfGroupsPrefix = '/list-of-groups';
export const newGroupPrefix = '/new-group';

export const groupsNewGroupUrl = `${newGroupPrefix}/`;

export const groupsNewGroupExplanationUrl = groupsNewGroupUrl;
export const groupsNewGroupSelectUrl = `${newGroupPrefix}/select/`;
export const groupsNewGroupFormUrl = `${newGroupPrefix}/:type(public|private)/`;
export const groupsEntityLikersUrl = `${groupPrefix}/likers/:type(comment|post)/${ENTITY_ID}/`;
export const groupsMyActivityFeedUrl = `${groupPrefix}/my-activity/`;
export const groupsSubscribedFeedUrl = `${groupPrefix}/subscribed/`;
export const groupsGroupUrl = `${groupPrefix}/${GROUP_ID}/`;
export const groupsGroupReportedUrl = `${groupPrefix}/${GROUP_ID}/reported/`;
export const groupsGroupInfoUrl = `${groupPrefix}/${GROUP_ID}/detail/`;
export const groupsGroupEditUrl = `${groupPrefix}/${GROUP_ID}/edit/`;
export const groupsGroupPhotosUrl = `${groupPrefix}/${GROUP_ID}/photos/`;
export const groupsGroupMembersUrl = `${groupPrefix}/${GROUP_ID}/members/`;
export const groupsGroupBlockMemberUrl = `${groupPrefix}/${GROUP_ID}/block-member/`;
export const groupsGroupBlockedMembersUrl = `${groupPrefix}/${GROUP_ID}/blocked-members/`;
export const groupsGroupInvitedMembersUrl = `${groupPrefix}/${GROUP_ID}/invited-members/`;
export const groupsGroupMembershipRequestsUrl = `${groupPrefix}/${GROUP_ID}/membership-requests/`;
export const groupsGroupInvitationUrl = `${groupPrefix}/${GROUP_ID}/invitation/:invitation/`;
export const groupsPhotoDetailUrl = `${groupPrefix}/${GROUP_ID}/${POST_SLUG}/${IMAGE_ID}/`;
export const groupsPostDetailUrl = `${groupPrefix}/${GROUP_ID}/${POST_SLUG}/`;
export const groupsPostEditUrl = `${groupPrefix}/post/${POST_ID}/edit/`;
export const groupsListOfGroupsUrl = `${listOfGroupsPrefix}/:category?/`;
